import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { academyLessonPath } from '@/lib/academy'

/** /academy/:lesson opens the Academy playing that lesson (the Academy shows what's published) */
const AcademyLesson: React.FC = () => {
  const { lesson } = useParams<{ lesson: string }>()
  return <Navigate to={lesson ? academyLessonPath(lesson) : '/academy'} replace />
}

export default AcademyLesson
